import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const StoreContext = createContext(null);
export const useStore = () => useContext(StoreContext);

const DEFAULT_COLORS = { bg: "#FDFDFD", text: "#0A121A", blue: "#0A1F3A", gold: "#D4AF37", surface: "#F4F5F7" };

function applyColors(colors) {
  const root = document.documentElement;
  root.style.setProperty("--bg", colors.bg);
  root.style.setProperty("--text", colors.text);
  root.style.setProperty("--blue", colors.blue);
  root.style.setProperty("--gold", colors.gold);
  root.style.setProperty("--surface", colors.surface);
}

export function StoreProvider({ children }) {
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem("tn_cart") || "[]"); } catch { return []; }
  });
  const [cartOpen, setCartOpen] = useState(false);
  const [settings, setSettings] = useState({ brand_name: "OOMINING", colors: DEFAULT_COLORS, content: {} });
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    api.get("/settings").then(({ data }) => {
      setSettings(data);
      applyColors(data.colors);
    }).catch(() => applyColors(DEFAULT_COLORS));
  }, []);

  useEffect(() => {
    localStorage.setItem("tn_cart", JSON.stringify(cart));
  }, [cart]);

  const addToCart = useCallback((product, quantity = 1) => {
    setCart((prev) => {
      const existing = prev.find((i) => i.product.id === product.id);
      if (existing) {
        return prev.map((i) => i.product.id === product.id ? { ...i, quantity: i.quantity + quantity } : i);
      }
      return [...prev, { product, quantity }];
    });
    setCartOpen(true);
  }, []);

  const updateQty = useCallback((id, quantity) => {
    setCart((prev) => quantity <= 0 ? prev.filter((i) => i.product.id !== id) : prev.map((i) => i.product.id === id ? { ...i, quantity } : i));
  }, []);

  const removeFromCart = useCallback((id) => setCart((prev) => prev.filter((i) => i.product.id !== id)), []);
  const clearCart = useCallback(() => setCart([]), []);

  const cartCount = cart.reduce((n, i) => n + i.quantity, 0);
  const cartTotal = cart.reduce((n, i) => n + i.product.price * i.quantity, 0);

  const refreshSettings = useCallback(async () => {
    const { data } = await api.get("/settings");
    setSettings(data);
    applyColors(data.colors);
  }, []);

  return (
    <StoreContext.Provider value={{
      cart, cartOpen, setCartOpen, addToCart, updateQty, removeFromCart, clearCart, cartCount, cartTotal,
      settings, setSettings, applyColors, refreshSettings, admin, setAdmin,
    }}>
      {children}
    </StoreContext.Provider>
  );
}
